import React from 'react';

// Third party
import { useFormContext, Controller } from 'react-hook-form';

// MUI
import { TextField, TextFieldProps } from '@mui/material';

type TRHFSelectProps = TextFieldProps & {
  name: string;
  native?: boolean;
  maxHeight?: boolean | number;
  children: React.ReactNode;
};

export function RHFSelect({
                            name,
                            native,
                            maxHeight = 220,
                            helperText,
                            children,
                            ...other
                          }: TRHFSelectProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          select
          fullWidth
          SelectProps={{
            native,
            MenuProps: {
              PaperProps: {
                sx: {
                  ...(!native && {
                    px: 1,
                    maxHeight: typeof maxHeight === 'number' ? maxHeight : 'unset',
                    '& .MuiMenuItem-root': {
                      px: 1,
                      borderRadius: 0.75,
                      textTransform: 'capitalize',
                    },
                    '& .MuiMenuItem-root.Mui-disabled': {
                      backgroundColor: 'transparent !important',
                    },
                  }),
                },
              },
            },
            sx: { textTransform: 'capitalize' },
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        >
          {children}
        </TextField>
      )}
    />
  );
}